import HeaderLink from "./HeaderLink";
import PlainLink from "./PlainLink";

export function ContractWithdrawalFragment() {
  return (
    <>
      <HeaderLink to="/ContractWithdrawal/new">Odstąpienie od umowy</HeaderLink>

      <PlainLink to="/ContractWithdrawal/new">Nowe zgłoszenie</PlainLink>
    </>
  );
}
